"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _KriptonioSdk_apiClient;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KriptonioSdk = void 0;
const Configuration_1 = require("./Configuration");
const ApiClient_1 = require("./api/ApiClient");
const PaymasterService_1 = require("./service/PaymasterService");
const RpcService_1 = require("./service/RpcService");
const SmartContractService_1 = require("./service/SmartContractService");
const WalletService_1 = require("./wallet/WalletService");
class KriptonioSdk {
    constructor(config) {
        _KriptonioSdk_apiClient.set(this, void 0);
        this.configure = (config) => {
            if (config.accessToken || config.sessionToken) {
                __classPrivateFieldGet(this, _KriptonioSdk_apiClient, "f").setAuthentication(config);
            }
            if (config.apiUrl) {
                Configuration_1.Configuration.apiUrl = config.apiUrl;
            }
            if (config.rpcApiUrl) {
                Configuration_1.Configuration.rpcApiUrl = config.rpcApiUrl;
            }
            if (config.paymasterApiUrl) {
                Configuration_1.Configuration.paymasterApiUrl = config.paymasterApiUrl;
            }
        };
        __classPrivateFieldSet(this, _KriptonioSdk_apiClient, new ApiClient_1.ApiClient({ accessToken: config.accessToken }), "f");
        this.rpc = new RpcService_1.RpcService(__classPrivateFieldGet(this, _KriptonioSdk_apiClient, "f"));
        this.paymaster = new PaymasterService_1.PaymasterService(__classPrivateFieldGet(this, _KriptonioSdk_apiClient, "f"));
        this.wallet = new WalletService_1.WalletService(this.rpc, this.paymaster);
        this.smartContract = new SmartContractService_1.SmartContractService(__classPrivateFieldGet(this, _KriptonioSdk_apiClient, "f"));
    }
}
exports.KriptonioSdk = KriptonioSdk;
_KriptonioSdk_apiClient = new WeakMap();
